import styles from "./ErrorModal.module.css";

const ErrorModal = ({ errorText, onClose }) => {
  // Обработчик клика по overlay (закрытие при клике вне модалки)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Оповещение</h3>
          <button 
            className={styles.closeButton} 
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        
        <div className={styles.content}>
          <p className={styles.errorText}>{errorText}</p>
        </div>
        
        <div className={styles.footer}>
          <button className={styles.okButton} onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;